import { createMuiTheme } from '@material-ui/core/styles';

/**
 * Recording Corey's Colors
 * Main Blue - #3E6BEC
 * Lighter Blue - #AFC2F9
 * Background Gray - #E5E5E5
 * Contrast White - #FFFFFF
 * Gray 1 - #333333
 * Gray 2 - #4F4F4F
 * Gray 3 - #828282
 * Gray 4 - #BDBDBD
 * Gray 5 - #72808A
 */

 /**
  * Recording Corey's Fonts
  * Inter - Weight 400 & 500
  * Roboto
  */

const theme = createMuiTheme({
    typography: {
        fontFamily: [
           'Inter',
           'sans-serif',
        ].join(','),
        h1: { //Login/Signup Header Variant
            color: '#828282',
            letterSpacing: '0.4px',
            fontWeight: '500',
            lineHeight: '30px',
            fontSize: '18px'
        },
        h2: { //Article Title Header Variant
            fontFamily: [
                'Roboto',
                'sans-serif'
            ].join(','),
            lineHeight: '30px',
            letterSpacing: '0.15px',
            fontSize: '18px'
        },
        h3:{ //Navbar Header Variant
            fontWeight: '500',
            fontSize: '14px',
            height: '100%',
            lineHeight: '21px',
            letterSpacing: '0.25px',
            textAlign: 'center',
            color: '#72808A'
        },
        //h4:{}
        h5:{ //Saved Search Header Variant
            fontFamily: [
                'Roboto',
                'sans-serif'
            ].join(','),
            fontWeight: '500',
            lineHeight: '24px',
            letterSpacing: '0.15px',
            fontSize: '18px'
        },
        h6: { //Accordian Header Variant
            fontFamily: [
                'Roboto',
                'sans-serif'
            ].join(','),
            color: '#828282',
            letterSpacing: '0.4px',
            fontWeight: '500',
            fontSize: '12px'
        },
        //subtitle1:{}
        //subtitle2:{}
        //body1:{}
        //body2:{}
        //caption:{}
        button: {
            fontWeight: '500',
            fontSize: '13px',
            lineHeight: '30px',
            textAlign: 'center'
        }
        //overline:{}
        //srOnly:{}
        //inherit:{}
    },
    palette: {
        primary: {
            //light: ,
            main: '#3E6BEC',
            //dark: ,
            contrastText: '#FFFFFF',
        },
        secondary: {
            //light: ,
            main: '#AFC2F9',
            dark: '#3E6BEC',
            contrastText: '#FFFFFF',
        },
        background: {
            default: '#F2F2F2 !important'
        },
        darkText: {
            main: '#0000008a'
        },
        error: {
            main: '#FD3A57'
        }
        //warning:{}
        //info:{}
        //success:{}
    },
});

export default theme;